// Import Routes
import * as ROUTES from "../routes";

import Dashboard from "@/modules/dashboard/views"
import Transactions from "@/modules/dashboard/views/transactions";
const routes = [
    {
        path: ROUTES.DASHBOARD,
        name: "Dashboard",
        component: Dashboard,
        meta: {
            title: "Dashboard",
            layout: "private",
            requiresAuth: true,
            nav: 'Dashoard'
        },
    },
    
    {
        path: ROUTES.DASHBOARD_TRANS,
        name: "transactions",
        component: Transactions,
        meta: {
            title: "Transactions",
            layout: "private",
            requiresAuth: true,
            nav: 'Dashoard/transactions'
        },
    }
    
]

export default routes;